import {
  LOCAL_STORAGE_KEYS,
  RESULT_COUNT_STATIC_TEXT_FROM_AEM,
  SEARCH_TERM_STATIC_TEXT_FROM_AEM,
} from "@/utils/constant";

export const truncateString = (
  query: string | undefined,
  maxLength: number
): string => {
  if (!query) return "";
  return query.length < maxLength
    ? query
    : `${query.substring(0, maxLength)}...`;
};

export const toTitleCase = (text: string) => {
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const articleCardDateFormat = (dateStr: string | Date) => {
  const date = new Date(dateStr);
  // Format to "Month Day, Year"
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export function isInViewport(
  element: HTMLElement | Element,
  visibilityThreshold: number = 75
): boolean {
  const rect = element.getBoundingClientRect();
  const elementHeight = rect.height;
  const elementWidth = rect.width;

  const visibleHeight =
    Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);
  const visibleWidth =
    Math.min(window.innerWidth, rect.right) - Math.max(0, rect.left);

  const visibleHeightPercentage = (visibleHeight / elementHeight) * 100;
  const visibleWidthPercentage = (visibleWidth / elementWidth) * 100;

  return (
    visibleHeightPercentage >= visibilityThreshold &&
    visibleWidthPercentage >= visibilityThreshold
  );
}


export const replaceAEMStaticText = (
  txt?: string,
  keys?: {
    searchQuery?: string;
    resultsCount?: string | number;
  }
): string | undefined => {
  if (txt && keys?.searchQuery)
    txt = txt.replace(SEARCH_TERM_STATIC_TEXT_FROM_AEM, keys?.searchQuery);
  if (txt && keys?.resultsCount)
    txt = txt.replace(RESULT_COUNT_STATIC_TEXT_FROM_AEM, String(keys?.resultsCount));
  return txt;
};

export const getGuestUserRandomId = () => {
  const localStorageKey = LOCAL_STORAGE_KEYS.ANONYMOUS_USER;
  let token = localStorage.getItem(localStorageKey);

  if (!token) {
    const timestamp = Date.now().toString(36);
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);
    const randomValues = Array.from(array)
      .map((value) => value.toString(36))
      .join("")
      .substring(0, 16);

    token = "anonymous-" + timestamp + randomValues;

    localStorage.setItem(localStorageKey, token);
  }

  return token;
};
